const colorSonstigeMin = '#f3f3f3';
const colorSonstigeMax = '#888';

module.exports = {
  CDU: {
    min: '#d8d8d8',
    max: '#373737',
    name: 'CDU'
  },
  SPD: {
    min: '#ffe3e1',
    max: '#DB4240',
    name: 'SPD'
  },
  'Grüne': {
    min: '#d6f3d4',
    max: '#4BA345',
    name: 'Grüne'
  },
  'Die.Linke': {
    min: '#fad5ed',
    max: '#96276E',
    name: 'Linke'
  },
  FDP: {
    min: '#fff7ce',
    max: '#F6BB00',
    name: 'FDP'
  },
  AfD: {
    min: '#cff6ff',
    max: '#34A3D2',
    name: 'AfD'
  },
  'Die.Partei': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Die Partei'
  },
  'NPD': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'NPD',
    shortname: 'NPD'
  },
  'Freie.Wähler': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Freie Wähler',
    shortname: 'FW'
  },
  'Familie': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Familie'
  },
  'Tierschutzpartei': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Tierschutzpartei',
    shortname: 'Tierschutzpartei'
  },
  'Piraten': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Piraten',
    shortname: 'Piraten'
  },
  'Volksabstimmung': {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Volksabstimmung',
    shortname: 'Volksabstimmung'
  },
  sonstige: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
    name: 'Sonstige',
    shortname: 'Sonst.'
  },
  nichtwaehler: {
    min: '#e4e8ec',
    max: '#6C7D97',
    name: 'Nichtwähler'
  },
  default: {
    min: colorSonstigeMin,
    max: colorSonstigeMax,
  }
};
